import Vuex from "vuex";
import Vuetify from "vuetify/lib/framework";
import "@mdi/font/css/materialdesignicons.min.css";
import it from "vuetify/es5/locale/it";
import account from "@/store/account";
import cud from "@/store/cud";
import document from "@/store/document";
import employee from "@/store/employee";
import payroll from "@/store/payroll";
import snackbar from "@/store/snackbar";

export function initVueXStore(vue) {
  vue.use(Vuex);
  return new Vuex.Store({
    modules: {
      account,
      document,
      cud,
      employee,
      payroll,
      snackbar
    },
  });
}

export function initVuetify(vue) {
  vue.use(Vuetify);
  return new Vuetify({
    lang: {
      locales: { it },
      current: "it"
    },
    icons: {
      iconFont: "md",
    },
  });
}
